module.exports = __webpack_public_path__ + "static/img/pMRI8.c426faa6.png";